import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import image1 from '../assets/images/aboout-us-home.jpg';
import '../assets/css/about-home.css';
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';

const About = () => {

    // const handleform = () => {}
    return (
        <section id="about" className='py-5 py-md-5'>
            <Container>
                <div id='about-us' className='flex'>
                    <div className='parent-div-va flex-image'>
                        <img className='img-fluid about-image' alt='Seva Sadhana' src="Health/Ambedkar-medicalcamp1.JPG" />
                    </div>
                    <div className='flex-content'>
                        <h2>About Us</h2>
                        <p>Seva Sadhana is NGO providing free support in remote areas of Kutch - Gujarat region.
                            Our NGO distribute Education Kit,provide health chekup, and run Skill enchancement programms. We are an 80G Govt Of India Registered Trust.
                            Seva Sadhana also Contributes in building homes in remote areas of kutch region. Currently 3 villages (Gorevalli, Luna, Bhittra) developement is completed by SEVA SADHANA.</p>
                        <p>Vision of Seva Sadhana is to support people in need. We find best suitbable place to donate. Let's come together and support people in need with your contribution.</p>
                        {/* <Link className="btn-primary" to="/">Know More <DoubleArrowRoundedIcon fontSize='small'/></Link> */}
                    </div>
                </div>
                <div className="about-cards-123 mt-5">
                    <div className="row g-4">

                        {[
                            {
                                title: "Education",
                                desc: "Education kits and learning support for children.",
                                image: "Education/Musical-ins-edu1.jpeg",
                                categoryLink: "education"
                            },
                            {
                                title: "Health",
                                desc: "Free medical check-ups and health camps.",
                                image: "Health/Ayurvedic-camp1.jpg",
                                categoryLink: "healthcare"
                            },
                            {
                                title: "Skill Enhancement",
                                desc: "Skill development programs for self-reliance.",
                                image: "Sewing_Class_Bani/SwingB1.jpeg",
                                categoryLink: "self-reliance"
                            },
                            {
                                title: "New Homes",
                                desc: "Building safe homes in remote villages.",
                                image: "Social/Temple-Bidada-Gokul4.jpeg",
                                categoryLink: "social-activity"
                            },
                            {
                                title: "Community Development",
                                desc: "Empowering communities through sustainable initiatives.",
                                image: "Handcarts2/H1.jpg",
                                categoryLink: "social-activity"
                            },
                            {
                                title: "Activities",
                                desc: "Click button below to explore all projects and initiatives by Seva Sadhana.",
                                isCTA: true
                            }
                        ].map((item, index) => (
                            <div className="col-md-6 col-lg-4" key={index}>
                                {item.isCTA ? (
                                    <div className={`about-card-123 cta-card`}>
                                        <div className="card-content-123 text-center">
                                            <h5>{item.title}</h5>
                                            <p>{item.desc}</p>
                                            <Link to="/activities" className="btn-primary-2">
                                                View All Activities <DoubleArrowRoundedIcon fontSize='small'/>
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <Link 
                                        to={`/activities?category=${item.categoryLink}`} 
                                        className="about-card-link"
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <div className={`about-card-123 image-card`}>
                                            <div className="image-wrapper">
                                                <img src={item.image} alt={item.title} />
                                                <div className="image-overlay" />
                                            </div>
                                            <div className="card-content-123 text-center">
                                                <h5>{item.title}</h5>
                                                <p>{item.desc}</p>
                                            </div>
                                        </div>
                                    </Link>
                                )}
                            </div>
                        ))}


                    </div>
                </div>



            </Container>
        </section>
    )
}

export default About